import { Quote } from "lucide-react";

const testimonials = [
  {
    quote:
      "Basically this planner is a use or ignore, guiltless planner that lets you choose what formats work for you. And it does not trap you in that for an entire year.",
    name: "Julie",
    location: "Texas",
  },
  {
    quote:
      "I cried reading through it. I have never seen anything like it. It feels like I have been in crowds of strangers averting their eyes, and suddenly someone made eye contact with me.",
    name: "Sofia",
    location: "Costa Rica",
  },
  {
    quote:
      "Do I use it every day? Hell no, I barely remember to eat regularly! But when I need it, it is extremely easy to pop a pre-printed page in my notebook and move on with my day instead of sifting through hundreds of unused planner pages glaring at me emptily.",
    name: "Helen",
    location: "Alabama",
  },
];

export default function SocialProofSection() {
  return (
    <section
      data-testid="social-proof-section"
      className="py-20 md:py-28"
      style={{ backgroundColor: "#1e1e1f" }}
    >
      <div className="max-w-6xl mx-auto px-5 md:px-12">
        <h2
          className="text-2xl sm:text-3xl lg:text-4xl font-medium leading-tight mb-14 text-center"
          style={{ fontFamily: "'Fraunces', serif", color: "#e0e0e0" }}
          data-testid="social-proof-heading"
        >
          What other inconsistent brains say about this system:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="rounded-2xl p-8 relative"
              style={{
                backgroundColor: "rgba(0,0,0,0.3)",
                backdropFilter: "blur(16px)",
                border: "1px solid rgba(255,255,255,0.08)",
              }}
              data-testid={`testimonial-card-${i}`}
            >
              <Quote
                className="w-8 h-8 mb-4 opacity-30"
                style={{ color: "#7C3AED" }}
              />
              <p
                className="text-base leading-relaxed mb-6"
                style={{ fontFamily: "'Inter', sans-serif", color: "#e0e0e0" }}
              >
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="flex items-center gap-2">
                <div
                  className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold"
                  style={{
                    background: "linear-gradient(135deg, #7C3AED, #6D28D9)",
                    color: "#fff",
                  }}
                >
                  {t.name[0]}
                </div>
                <div>
                  <p
                    className="text-sm font-medium"
                    style={{ color: "#e0e0e0", fontFamily: "'Inter', sans-serif" }}
                  >
                    {t.name}
                  </p>
                  <p
                    className="text-xs"
                    style={{ color: "#b0b0b5", fontFamily: "'Inter', sans-serif" }}
                  >
                    {t.location}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
